import React from 'react'
import PublicationsBook from '../components/screens/publications/book/PublicationsBook'
import PublicationsFanzines from '../components/screens/publications/fanzines/PublicationsFanzines'
import PublicationsArticles from '../components/screens/publications/articles/PublicationsArticles'
import NewsletterCTA from '../components/NewsletterCTA'
import './publications.css'

const Publications = () => {
  return (
    <main className='publications-page'>
      <PublicationsBook />
      <PublicationsFanzines />
      <PublicationsArticles />
      <NewsletterCTA />
    </main>
  )
}

export default Publications
